import { jsx } from 'react/jsx-runtime';
import { Radio } from '../../Radio/Radio.js';

const DropdownRadio = ({
  className,
  ...rest
}) => {
  return /* @__PURE__ */ jsx("div", { className: "dropdown__radio", children: /* @__PURE__ */ jsx(Radio, { className, ...rest }) });
};

export { DropdownRadio as default };
